import { APIClient } from "../api_helper";
import * as url from "../url_helper";

const api = new APIClient();

export const deviceRegisterAPI = data => {
    return api.create(url.DEVICE_REGISTER(data), data);
}
